import '@/lib/errorReporter';
import { enableMapSet } from "immer";
enableMapSet();
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { RouteErrorBoundary } from '@/components/RouteErrorBoundary';
import '@/index.css'
import { HomePage } from '@/pages/HomePage'
import { WizardPage } from '@/pages/WizardPage'
import { ResultsPage } from '@/pages/ResultsPage'
import { CatalogPage } from '@/pages/CatalogPage'
import { CartPage } from '@/pages/CartPage'
import { CheckoutPage } from '@/pages/CheckoutPage'
import { OrderSuccessPage } from '@/pages/OrderSuccessPage'
import { AdminPage } from '@/pages/AdminPage'
import { PricingPage } from '@/pages/PricingPage'
import { MarketplacePackagesPage } from '@/pages/MarketplacePackagesPage'
import { MarketplaceHarvestsPage } from '@/pages/MarketplaceHarvestsPage'
import { SellerDashboardPage } from '@/pages/SellerDashboardPage'
import { TermsOfServicePage } from '@/pages/TermsOfServicePage'
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage'
import { ListingGuidelinesPage } from '@/pages/ListingGuidelinesPage'
import { LoginPage } from '@/pages/LoginPage'
import { AccountPage } from '@/pages/AccountPage'
import { PostPurchasePage } from '@/pages/PostPurchasePage'
import { Toaster } from '@/components/ui/sonner'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
const queryClient = new QueryClient();
const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/wizard",
    element: <WizardPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/results",
    element: <ResultsPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/catalog",
    element: <CatalogPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/cart",
    element: <CartPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/order-success/:id",
    element: <OrderSuccessPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/admin",
    element: <ProtectedRoute requireAdmin><AdminPage /></ProtectedRoute>,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/marketplace/packages",
    element: <MarketplacePackagesPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/marketplace/harvests",
    element: <MarketplaceHarvestsPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/seller/dashboard",
    element: <SellerDashboardPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/account",
    element: <AccountPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/terms",
    element: <TermsOfServicePage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicyPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/listing-guidelines",
    element: <ListingGuidelinesPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/my-farm-guide",
    element: <PostPurchasePage />,
    errorElement: <RouteErrorBoundary />,
  },
]);
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <RouterProvider router={router} />
        <Toaster richColors position="top-right" />
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
)